import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { useQuery, useQueryClient } from 'react-query';

import BillingService from '../../services/BillingService';
import TierService from '../../services/TierService';
import { ORG_ROLES } from '../../constants/main';
import { UiContext } from '../../context/UiContext';
import PlansSection from '../../pages/OrganizationSettingsPage/BillingPage/PlansSection';
import { logout } from '../../helpers/globalAuth';

import classes from './styles.module.scss';

export default function TrialExpiredModal({ show, me }) {
  const { notifyError } = useContext(UiContext);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const isOrgOwner = me?.orgRole?.access === ORG_ROLES.OWNER;
  const trialEndsAt = me?.organizationBilling?.trialEndsAt || null;
  const tierSnapshot = me?.Organization?.metadata?.tierSnapshot || me?.organization?.metadata?.tierSnapshot || {};

  const { data: tiers } = useQuery('tiers-public', TierService.listPublic, {
    enabled: !!show,
  });

  const handleUpgrade = async (tierId) => {
    try {
      const { data } = await BillingService.createCheckoutSession(tierId);
      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      notifyError(error?.response?.data?.message || 'Failed to start upgrade');
    }
  };

  const handlePortal = async () => {
    try {
      const { data } = await BillingService.createPortalSession();
      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      notifyError(error?.response?.data?.message || 'Failed to open billing portal');
    }
  };

  const handleSignOut = () => {
    logout(() => {
      queryClient.removeQueries();
      navigate('/');
    });
  };

  return (
    <Modal
      show={!!show}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName={classes.TrialExpiredModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
      onHide={() => {}}
    >
      <div className={classes.content}>
        <h3>Your trial has ended</h3>
        <p className={classes.subtitle}>
          {trialEndsAt
            ? `Your trial ended on ${new Date(trialEndsAt).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
              })}.`
            : 'Your trial has ended.'}{' '}
          Please select a plan to continue using Snap SOP.
        </p>

        {!isOrgOwner ? (
          <div className={classes.notice}>
            Only organization owners can manage billing. Please contact your organization owner to upgrade.
          </div>
        ) : null}

        <PlansSection
          tiers={tiers?.data || []}
          tierSnapshot={tierSnapshot}
          onUpgrade={handleUpgrade}
          onPortal={handlePortal}
          canUpgrade={isOrgOwner}
        />
        <div className={classes.supportNote}>
          Need more time to try out Snap SOP? Contact{' '}
          <a href="mailto:support@snapsop.com" className={classes.supportLink}>
            support@snapsop.com
          </a>{' '}
          to request an extension.
        </div>
        <div className={classes.footerRow}>
          <button type="button" className={classes.signOutLink} onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </div>
    </Modal>
  );
}
